import _extends from "@babel/runtime-corejs3/helpers/extends";
import _asyncToGenerator from "@babel/runtime-corejs3/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import _regeneratorRuntime from "@babel/runtime-corejs3/regenerator";
import _parseInt from "@babel/runtime-corejs3/core-js-stable/parse-int";
// Library Imports`
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, InputField } from '@unite-us/ui';
import './HouseholdMonthlyIncomeForm.scss';
import { Field, Form } from 'react-final-form';
import { callbacks, getAdapter, trackEvent } from '../../../config/api';
import { isEmpty, first } from 'lodash';
import callOrLog from '../../../constants/callOrLog';
import { FACESHEET } from '../../../constants/eventConstants';
function HouseholdMonthlyIncomeForm(props) {
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    formErrors = _useState2[0],
    setFormErrors = _useState2[1];
  var onSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(value) {
      var gross_monthly_income;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            gross_monthly_income = _parseInt(value.gross_monthly_income, 10);
            _context.next = 3;
            return getAdapter('coreApi').updateRecord("person", contact.id, {
              gross_monthly_income: gross_monthly_income
            });
          case 3:
            callOrLog(function () {
              return trackEvent(FACESHEET.grossMonthylIncomeUpdated);
            });
            props.closeModal();
            callbacks.onClientSaved();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var formValidator = {
    monthlyIncomeValidator: function monthlyIncomeValidator(value) {
      var errors = {};
      if (!isEmpty(value) && !value.match(/^\d+$/)) {
        errors.whole_number_income = 'Enter a whole number income.';
        if (isEmpty(formErrors)) {
          setFormErrors(errors.whole_number_income);
        }
        return errors.whole_number_income;
      }
      return '';
    }
  };
  var contact = props.contact;
  return /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit,
    initialValues: contact,
    render: function render(_ref2) {
      var handleSubmit = _ref2.handleSubmit,
        submitting = _ref2.submitting;
      return /*#__PURE__*/React.createElement("form", {
        onSubmit: handleSubmit,
        className: "household-monthly-income-form content-with-actions"
      }, /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "household-monthly-income-field"
      }, /*#__PURE__*/React.createElement(Field, {
        name: "gross_monthly_income",
        validate: formValidator.monthlyIncomeValidator
      }, function (params) {
        return /*#__PURE__*/React.createElement(InputField, _extends({
          id: "household-monthly-income-input-field",
          label: /*#__PURE__*/React.createElement("div", null, "Household Gross", /*#__PURE__*/React.createElement("br", null), "Monthly Income")
        }, params));
      }))), /*#__PURE__*/React.createElement("div", {
        className: "actions"
      }, /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-monthly-income-cancel-btn",
        onClick: props.closeModal,
        disabled: submitting,
        label: "Cancel"
      })), /*#__PURE__*/React.createElement("span", {
        className: "action-item"
      }, /*#__PURE__*/React.createElement(Button, {
        id: "edit-monthly-income-save-btn",
        disabled: submitting,
        label: "Save",
        primary: true,
        onClick: function onClick() {
          if (!isEmpty(formErrors)) {
            setTimeout(function () {
              var _focusableErr;
              var focusableErr;
              var err = first(document.getElementsByClassName('ui-form-field--has-error'));
              if (err) {
                var editHouseholdMonthlyIncomeModal = document.getElementById('edit-household-monthly-income-modal');
                var errInModal = first(editHouseholdMonthlyIncomeModal === null || editHouseholdMonthlyIncomeModal === void 0 ? void 0 : editHouseholdMonthlyIncomeModal.getElementsByClassName('ui-form-field--has-error'));
                focusableErr = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
              }
              if (focusableErr) {
                focusableErr.ariaLabel = formErrors;
              }
              (_focusableErr = focusableErr) === null || _focusableErr === void 0 || _focusableErr.focus();
              setFormErrors({});
            }, 300);
          } else if (first(document.getElementsByClassName('ui-form-field--has-error'))) {
            var editHouseholdMonthlyIncomeModal = document.getElementById('edit-household-monthly-income-modal');
            var errInModal = first(editHouseholdMonthlyIncomeModal === null || editHouseholdMonthlyIncomeModal === void 0 ? void 0 : editHouseholdMonthlyIncomeModal.getElementsByClassName('ui-form-field--has-error'));
            var focusableErr = first(errInModal === null || errInModal === void 0 ? void 0 : errInModal.getElementsByTagName('input'));
            focusableErr === null || focusableErr === void 0 || focusableErr.focus();
          }
          handleSubmit();
        }
      }))));
    }
  });
}
HouseholdMonthlyIncomeForm.propTypes = {
  closeModal: PropTypes.func,
  contact: PropTypes.object.isRequired
};
export default HouseholdMonthlyIncomeForm;
//# sourceMappingURL=HouseholdMonthlyIncomeForm.js.map